/**
 * Created by Alex on 8/10/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { of as observableOf, Observable } from 'rxjs';

import { map, catchError, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { AutoTaggingService } from '../services/auto-tagging.service';
import {
    EDIT_AUTO_TAG_SETTINGS, EDIT_AUTO_TAG_SETTINGS_FAIL, EDIT_AUTO_TAG_SETTINGS_SUCCESS,
    GET_AUTO_TAG_MODEL, GET_AUTO_TAG_MODEL_SUCCESS, GET_AUTO_TAG_MODEL_FAIL,
    CHANGE_AUTO_TAG_STATUS, CHANGE_AUTO_TAG_STATUS_SUCCESS, CHANGE_AUTO_TAG_STATUS_FAIL,
    CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE, CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_SUCCESS,
    CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_FAIL, CREATE_AUTO_TAG_MODEL, CREATE_AUTO_TAG_MODEL_SUCCESS,
    CREATE_AUTO_TAG_MODEL_FAIL
} from './auto-tagging.actions';
import { AutoTagging } from '../models/auto-tagging.model';

@Injectable()
export class AutoTaggingEffects {

    constructor(private _actions$: Actions, private _autoTaggingService: AutoTaggingService) { }

    getAutoTagModelEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_AUTO_TAG_MODEL),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._autoTaggingService.getAutoTagModels().pipe(
            map(response => {
                return ({
                    type: GET_AUTO_TAG_MODEL_SUCCESS,
                    payload: response
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_AUTO_TAG_MODEL_FAIL, payload: err.message });
            }))
        )));

    editAutoTagStatusEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CHANGE_AUTO_TAG_STATUS),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._autoTaggingService.editAutoTagStatus(payload.enable).pipe(
            map(response => {
                return ({
                    type: CHANGE_AUTO_TAG_STATUS_SUCCESS,
                    payload: response
                });
            }),
            catchError(err => {
                return observableOf({ type: CHANGE_AUTO_TAG_STATUS_FAIL, payload: err.message });
            }))
        )));

    editAutoTagStatusForLiveWireEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._autoTaggingService.editAutoTagStatusForLiveWire(payload.enableForLiveWire).pipe(
            map(response => {
                return ({
                    type: CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_SUCCESS,
                    payload: response
                });
            }),
            catchError(err => {
                return observableOf({ type: CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_FAIL, payload: err.message });
            }))
        )));

    editAutoTagSettingsEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EDIT_AUTO_TAG_SETTINGS),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._autoTaggingService.editAutoTagSettings(payload.enable, payload.model, payload.noteTypes,
            payload.confidence).pipe(
                map(response => {
                    const autoTagging = AutoTagging.parse(response);
                    return ({
                        type: EDIT_AUTO_TAG_SETTINGS_SUCCESS,
                        payload: autoTagging
                    });
                }),
                catchError(err => {
                    return observableOf({ type: EDIT_AUTO_TAG_SETTINGS_FAIL, payload: err.message });
                }))
        )));

    createAutoTagModelEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_AUTO_TAG_MODEL),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._autoTaggingService.createAutoTagModel(payload.modelName, payload.noteTypes, payload.number).pipe(
            map(response => {
                return ({
                    type: CREATE_AUTO_TAG_MODEL_SUCCESS,
                    payload: response
                });
            }),
            catchError(err => {
                return observableOf({ type: CREATE_AUTO_TAG_MODEL_FAIL, payload: err.message });
            }))
        )));
}
